"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var TableauQuillV1AuthoringConfigurationFormatEnum;
(function (TableauQuillV1AuthoringConfigurationFormatEnum) {
    TableauQuillV1AuthoringConfigurationFormatEnum["Bullets"] = "BULLETS";
    TableauQuillV1AuthoringConfigurationFormatEnum["Paragraph"] = "PARAGRAPH";
})(TableauQuillV1AuthoringConfigurationFormatEnum = exports.TableauQuillV1AuthoringConfigurationFormatEnum || (exports.TableauQuillV1AuthoringConfigurationFormatEnum = {})); /**
* @export
* @enum {string}
*/
var TableauQuillV1AuthoringConfigurationVerbosityEnum;
(function (TableauQuillV1AuthoringConfigurationVerbosityEnum) {
    TableauQuillV1AuthoringConfigurationVerbosityEnum["Medium"] = "MEDIUM";
    TableauQuillV1AuthoringConfigurationVerbosityEnum["Low"] = "LOW";
    TableauQuillV1AuthoringConfigurationVerbosityEnum["High"] = "HIGH";
})(TableauQuillV1AuthoringConfigurationVerbosityEnum = exports.TableauQuillV1AuthoringConfigurationVerbosityEnum || (exports.TableauQuillV1AuthoringConfigurationVerbosityEnum = {}));
function TableauQuillV1AuthoringConfigurationFromJSON(json) {
    return TableauQuillV1AuthoringConfigurationFromJSONTyped(json, false);
}
exports.TableauQuillV1AuthoringConfigurationFromJSON = TableauQuillV1AuthoringConfigurationFromJSON;
function TableauQuillV1AuthoringConfigurationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'format': !runtime_1.exists(json, 'format') ? undefined : json['format'],
        'verbosity': !runtime_1.exists(json, 'verbosity') ? undefined : json['verbosity'],
        'selectionMade': !runtime_1.exists(json, 'selection_made') ? undefined : json['selection_made'],
        'useDerivedMeasureOrder': !runtime_1.exists(json, 'use_derived_measure_order') ? undefined : json['use_derived_measure_order'],
        'numDrilldownSections': !runtime_1.exists(json, 'num_drilldown_sections') ? undefined : json['num_drilldown_sections'],
        'customContent': !runtime_1.exists(json, 'custom_content') ? undefined : _1.GoogleProtobufStructFromJSON(json['custom_content']),
    };
}
exports.TableauQuillV1AuthoringConfigurationFromJSONTyped = TableauQuillV1AuthoringConfigurationFromJSONTyped;
function TableauQuillV1AuthoringConfigurationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'format': value.format,
        'verbosity': value.verbosity,
        'selection_made': value.selectionMade,
        'use_derived_measure_order': value.useDerivedMeasureOrder,
        'num_drilldown_sections': value.numDrilldownSections,
        'custom_content': _1.GoogleProtobufStructToJSON(value.customContent),
    };
}
exports.TableauQuillV1AuthoringConfigurationToJSON = TableauQuillV1AuthoringConfigurationToJSON;
